import { render, staticRenderFns } from "./AdviserFaqCategories.vue?vue&type=template&id=583a53a5&scoped=true"
import script from "./AdviserFaqCategories.vue?vue&type=script&lang=js"
export * from "./AdviserFaqCategories.vue?vue&type=script&lang=js"
import style0 from "./AdviserFaqCategories.vue?vue&type=style&index=0&id=583a53a5&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "583a53a5",
  null
  
)

export default component.exports